import React, { useEffect } from "react";
import { UseFormReturn } from "react-hook-form";
import { Input, Select, Textarea } from "../../../components/form";
import { Button } from "../../../components/button";
import { UserRole, VisitOutcome } from "../../../__generated__/globalTypes";
import { visitOutcomeLabel } from "../../../helpers/enum-labels";
import { useCustomers } from "../../customers/hooks";
import { useUsers } from "../../users/hooks";
import { useMe } from "../../users/hooks/useMe";

interface IVisitForm {
  loading: boolean;
  form: UseFormReturn<any, any>;
  submit: any;
  isEditing?: boolean;
}

export const VisitForm: React.FC<IVisitForm> = ({
  loading,
  form,
  submit,
  isEditing,
}) => {
  const { data: customersData } = useCustomers({ where: {} });
  const { data: usersData } = useUsers({ where: {}, limit: 100, offset: 0 });
  const { data: meData } = useMe();

  const isAdmin = meData?.me?.role === UserRole.Admin;

  useEffect(() => {
    if (!isEditing && meData?.me?.id && !form.getValues("salesRepId")) {
      form.setValue("salesRepId", meData.me.id);
    }
  }, [meData, isEditing]);

  useEffect(() => {
    if (!isEditing && !form.getValues("visitDate")) {
      form.setValue("visitDate", new Date().toISOString().slice(0, 10));
    }
  }, [isEditing]);

  return (
    <div className="w-full">
      <div className="flex flex-wrap gap-3">
        <Select
          label="Client"
          className="w-full"
          value={form.watch("customerId") ?? ""}
          {...form.register("customerId", { required: true, valueAsNumber: true })}
        >
          <option value="">-</option>
          {customersData?.customers?.results?.map((customer) => (
            <option key={customer.id} value={customer.id}>
              {customer.name}
            </option>
          ))}
        </Select>
        <Select
          label="Commercial"
          className="w-full"
          value={form.watch("salesRepId") ?? ""}
          disabled={!isAdmin}
          {...form.register("salesRepId", { required: true, valueAsNumber: true })}
        >
          <option value="">-</option>
          {usersData?.users?.results?.map((user) => (
            <option key={user.id} value={user.id}>
              {user.firstname} {user.lastname}
            </option>
          ))}
        </Select>
        <Input
          label="Date de visite"
          type="date"
          className="w-full"
          value={form.watch("visitDate") ?? ""}
          {...form.register("visitDate", { required: true })}
        />
        <Select label="Résultat" className="w-full" {...form.register("outcome", { required: true })}>
          <option value="">-</option>
          {Object.keys(VisitOutcome).map((outcome) => (
            <option key={outcome} value={outcome}>
              {visitOutcomeLabel(outcome)}
            </option>
          ))}
        </Select>
        <Input
          label="Date de relance"
          type="date"
          className="w-full"
          {...form.register("followUpDate")}
        />
        <Textarea
          label="Compte-rendu"
          className="w-full"
          {...form.register("report", { required: "Compte-rendu requis" })}
        />
      </div>

      <div className="w-full mt-4">
        <Button onClick={submit} loading={loading} disabled={loading}>
          Valider
        </Button>
      </div>
    </div>
  );
};
